<section>




  <div class="row py-4">
    <div class="col-12 d-flex justify-content-between px-5">
      <h2 class="text-left text-white px-3 my-4"> Crear mitigacion riesgo</h2>

      <div class="d-flex justify-content-center align-items-center mx-3">
        <button
        class="badge rounded-pill btn btn-outline-light mx-2"
        [routerLink]="['./..']"
      >
        <i
          class="fa-solid fa-right-from-bracket m-2 fs-6"
          aria-hidden="true"
        ></i>
        <span class="m-2 fs-6">Volver</span>
      </button>


      </div>


    </div>
  </div>

  <div class="container-fluid px-5">

    <br>
    <div class="row backgroundTable card">
      <div class="card-header">
        <h5 class="text-white p-3 "> Crear mitigaciones</h5>
      </div>
      <div class="card-body componente-importantes-from-popup">
        <form
          action=""
          method="post"
          (submit)="formSubmit()"
         [formGroup]="mitigationCreateForm"
        >
        <div class="col-12 p-3">
            <div class="form-group px-3 pb-3">
                <label for="mitigationsRisk" class="text-white">Mitigacion del riesgo</label>
                <input type="text" required class="form-control custom-outline-input" id="description" name="description" placeholder="Descripcion de como mitigar el riesgo" formControlName="description">
            </div>

            <div class="form-group px-3 pb-3">
                <label for="person" class="text-white">Responsable</label>
                <select required class="form-control custom-outline-input" formControlName="users_id" id="users_id">
                    <option Selected value="">Seleccione un responsable</option>
                    <option *ngFor="let item of listAssigned"  [value]="item.users_id">{{item.username}}</option>
                </select>
            </div>

            <div class="form-group px-3 pb-3">
                <label for="calification" class="text-white">Clasificacion</label>
                <select required class="form-control custom-outline-input" formControlName="calification" id="calification">
                    <option Selected value="">Seleccione una clasificacion</option>
                    <option *ngFor="let item of listCalification" [value]="item.id">{{ item.name }}</option>
                </select>
            </div>

            <div class="form-group px-3 pb-3">
                <label for="action_date" class="text-white">Fecha Accion</label>
                <input type="date" required class="form-control custom-outline-input date" id="action_date" name="action_date"  formControlName="action_date">
            </div>

            <div class="form-group px-3 pb-3">
                <label for="mitigation_deadline_date" class="text-white">Fecha limite de mitigacion</label>
                <input type="date" required class="form-control custom-outline-input date" id="mitigation_deadline_date" name="mitigation_deadline_date"  formControlName="mitigation_deadline_date">
            </div>
            <div class="form-group d-flex justify-content-sm-end py-3">
                <!-- <button [routerLink]="['./..']" class="mx-2 btn btn-outline-light "><i class="fa fa-arrow-left" aria-hidden="true"></i> Volver a la etapa anterior</button> -->
                <button type="submit" class="btn btn-outline-light me-3"><i _ngcontent-xfk-c127="" class="fa-solid fa-floppy-disk m-1"></i>Guardar mitigacion</button>
            </div>

        </div>
        
    
    
    </form>
      </div>
    </div>
  </div>
</section>
